<template>
    <section :class="bodyClass">
        <div class="search-settings">
            <ExportDialog @ok="selectExportMode" :dialogId="exportDialogId" getter="getChannelsExportQuery" setter="setChannelsExportQuery" />
            <div v-if="channelsInitStatus == 'LOADING'">
                <div v-if="loadingFormData" class="text-center mb-2">
                    <b-progress :value="loadingFormDataValue" show-progress class="m-5" />
                </div>
            </div>
            <div class="failedRequest" v-if="channelsInitStatus == 'FAILED'">Cannot return result due to a server error.</div>
            <div v-if="channelsInitStatus == 'LOADED'">
                <b-form>
                    <b-form-row class="justify-content-center mb-2">
                        <DateModalChannels :fieldData="formFields.date" @onInputChanged="inputChanged" :latestDate="latestDate" />
                        <ProviderPickerChannels :fieldData="formFields.providers" getter="getChannelsQuery" providersSetter="setChannelsQueryProviders" setter="setChannelsQuery" />
                        <TargetGroupChannels :fieldData="formFields.target_group" getter="getChannelsQuery" setter="setChannelsQuery" />
                    </b-form-row>
                    <b-form-row class="mb-2 justify-content-center">
                        <button v-if="getSelectedInputs > 0" type="button" class="trashbtn mt-2 mr-2" @click="clearAllFields">
                            <b-icon-trash />
                        </button>
                        <div v-for="(selectedButton, key) in selectedBtns" :key="key">
                            <button class="selectedbtns mr-2 mt-2 bubblefontsize" type="button" @click="selectedButton.clickedBtn && selectedButton.clickedBtn()">
                                <span v-html="selectedButton.text" />
                                <b-icon
                                    v-if="selectedButton.editable"
                                    class="ml-2 crossbtn"
                                    font-scale="1.5"
                                    icon="x"
                                    @click="selectedButton.clickedBtnDelete && selectedButton.clickedBtnDelete($event)"
                                />
                            </button>
                        </div>
                    </b-form-row>
                </b-form>

                <b-form-row class="mb-2 justify-content-center">
                    <div>
                        <b-button :disabled="disableRunBtn" @click="submitSearch" class="searchbutton" variant="primary" size="sm">
                            <font-awesome-icon v-if="status != 'LOADING'" style="font-size: 1rem; position: relative; top: 1px; right: 2px;" :icon="['fas', 'play']" />
                            {{ status === "LOADING" ? "Working..." : "Run" }}
                        </b-button>
                    </div>
                </b-form-row>
                <div v-if="!TargetGroupExists">
                    <div class="text-center mb-2">
                        <div>
                            <small class="text-danger"><strong>You must select a target group under Target Groups / Measures.</strong></small>
                        </div>
                    </div>
                </div>
                <div v-if="exceededConsumptionPeriodLimit">
                    <div class="text-center mb-2">
                        <div>
                            <small class="text-danger"
                                ><strong>You can select a maximum of {{ config_NumberOfConsumptionDaysChannel }} days as consumption period.</strong></small
                            >
                        </div>
                    </div>
                </div>
                <ConfirmDialog
                    dialogTitle="Recommendation for analyses"
                    @cancel="onCancelDialog"
                    :dialogMessage="messageExceededRecommendedPeriod"
                    :dialogId="exceededRecommendedPeriodDialogId"
                    :dialogVerticalCenter="true"
                >
                    <template v-slot:modal-footer>
                        <b-button size="sm" variant="outline-secondary" @click="onCancelDialog">
                            Cancel
                        </b-button>
                        <b-button size="sm" variant="primary" @click="acceptExceededRecommendedPeriod">
                            Ok
                        </b-button>
                    </template>
                </ConfirmDialog>
            </div>
            <hr />
        </div>
        <div class="tab-section">
            <b-tabs nav-wrapper-class="tab-nav" :content-class="tabContentContainer" v-model="tabIndex" :class="tabContainerClass" @activate-tab="handleTabActivation">
                <b-tab title="List" @click="showChartStyle(false)">
                    <Spinner v-if="status == 'LOADING'" loadingMsg="Loading results..." />
                    <div v-else-if="status == 'EMPTY_RESULT'">Found nothing for current search</div>
                    <div v-else-if="status == 'LOADED'">
                        <ResultTableMainChannel @onChartButtonClicked="handleChartButtonClick" :sortBy.sync="mainSortBy" :sortDesc.sync="mainSortDesc" />
                    </div>
                    <div class="failedRequest" v-else-if="status == 'FAILED'">Cannot return result due to a server error.</div>
                    <div v-else-if="status == 'VALIDATION_FAILED'" class="text-danger">
                        <span v-bind:key="index" v-for="(error, index) in formErrors" class="d-block">
                            {{ error }}
                        </span>
                    </div>
                </b-tab>
                <b-tab v-if="config_ShowReachFrequencyChannel" :title="rofTabTitle" :disabled="isRofTabDisabled">
                    <ChannelReach :tabIndex="tabIndex" :exceededRecommendedPeriodLimit="exceededRecommendedPeriodLimit" :loadRofTab="loadRofTab" @setLoadRofTabBool="setLoadRofTabBool"></ChannelReach>
                </b-tab>
                <b-tab title="Chart" @click="showChartStyle(true)" class="chart-content" :disabled="status !== 'LOADED'">
                    <Spinner v-if="status == 'LOADING'" loadingMsg="Loading chart..." />
                    <div v-else-if="status == 'EMPTY_RESULT'">Found nothing for current search</div>
                    <ResultDiagramMainChannel v-else-if="status == 'LOADED'" class="line-chart" />
                    <div class="failedRequest" v-if="status == 'FAILED'">Cannot return result due to a server error.</div>
                    <div v-else-if="status == 'VALIDATION_FAILED'" class="text-danger">
                        <span v-bind:key="index" v-for="(error, index) in formErrors" class="d-block">
                            {{ error }}
                        </span>
                    </div>
                </b-tab>
                <template v-slot:tabs-end>
                    <div class="ml-auto">
                        <b-button class="mb-2 align-baseline mr-2" size="sm" variant="primary" @click="showOrHideSumInTable" :disabled="disableSumBtn" v-if="showSumBtn"
                            >{{ sumVisible ? "Hide summary" : "Show summary" }}
                        </b-button>
                        <b-button
                            :disabled="loadingExportResults"
                            class="ml-auto"
                            size="sm"
                            variant="success"
                            @click="userClickedExport"
                            v-if="status === 'LOADED' && tabName === 'List'"
                            v-b-tooltip.hover
                            title="Export the result on screen"
                        >
                            <font-awesome-icon style="font-size: 1rem; position: relative; top: 1px; right: 2px;" :icon="['fas', 'file-export']" />
                            {{ loadingExportResults ? "Working..." : "Export" }}
                        </b-button>
                        <b-button
                            :disabled="loadingExportResults"
                            class="ml-auto"
                            size="sm"
                            variant="success"
                            @click="userClickedExportRoF"
                            v-if="statusRof == 'LOADED' && tabName === 'Reach and frequency'"
                            v-b-tooltip.hover
                            title="Export the result on screen"
                        >
                            <font-awesome-icon style="font-size: 1rem; position: relative; top: 1px; right: 2px;" :icon="['fas', 'file-export']" />
                            {{ loadingExportResults ? "Working..." : "Export" }}
                        </b-button>
                    </div>
                </template>
                <SlowQueryModal :show="showSlowQueryModal" :loading="loadingExportResults" @download="handleDownloadSlowQueryModal" @cancel="handleCancelSlowQueryModal" />
                <ScheduleReportModal :show="showScheduleReportModal" :loading="loadingScheduleReport" @submit="handleScheduleReportSubmit" @cancel="handleScheduleReportCancel" />
            </b-tabs>
        </div>
    </section>
</template>

<script>
import SlowQueryModal from "../../Shared/SlowQueryModal/SlowQueryModal.vue"
import ScheduleReportModal from "../../Shared/ScheduleReportModal/ScheduleReportModal.vue"
import ChannelReach from "./ChannelReach"
import Spinner from "@/components/Shared/Spinner/Spinner"
import { baseFields } from "./formData"
import { validationRules } from "./channelValidationRules"
import inputValidation from "@/mixins/inputValidation"
import { mapState } from "vuex"
import * as Actions from "@/store/modules/channels/action-types"
import * as Mutations from "@/store/modules/channels/mutation-types"
import { download, dateToyymmddFormat, scrollToBottom, daysBetweenDates, getChannelDatePeriod, determineApiVersion } from "../../../api/utils.js"
import dayjs from "dayjs"
import ResultTableMainChannel from "@/components/Layout/Channels/ResultTableMainChannel"
import ResultDiagramMainChannel from "@/components/Layout/Channels/ResultDiagramMainChannel"
import ExportDialog from "@/components/Shared/FormElement/Dialogs/ExportDialog"
import globalConfig from "../../../mixins/globalConfig"
import ConfirmDialog from "@/components/Shared/FormElement/Dialogs/ConfirmDialog"
import DateModalChannels from "./DateModalChannels"
import ProviderPickerChannels from "./ProviderPickerChannels"
import TargetGroupChannels from "../../Shared/FormElement/TargetGroup/TargetGroupChannels"

export default {
    name: "Channels",
    components: {
        ChannelReach,
        Spinner,
        ResultTableMainChannel,
        ResultDiagramMainChannel,
        ExportDialog,
        ConfirmDialog,
        SlowQueryModal,
        ScheduleReportModal,
        DateModalChannels,
        ProviderPickerChannels,
        TargetGroupChannels,
    },
    mixins: [inputValidation, globalConfig],
    beforeDestroy() {
        document.removeEventListener("keyup", this.onKeyUp)
    },
    data() {
        return {
            showScheduleReportModal: false,
            loadingScheduleReport: false,
            showSlowQueryModal: false,
            loadingFormData: true,
            loadingFormDataValue: 0,
            loadingSearchResults: false,
            formFields: baseFields,
            columnsField: {
                config: { options: [] },
                identifier: "columns",
                label: "Show columns",
            },
            selectAll: false,
            calledGetChannels: false,
            tabName: "List",
            targetLabel: "",
            message: "",
            formErrors: [],
            loadingExportResults: false,
            tabIndex: 0,
            exportDialogId: "sites-export-modal",
            bodyClass: "body",
            tabContainerClass: "",
            tabContentContainer: "mt-3 table-content-container",
            mainSortBy: "providerName",
            mainSortDesc: false,
            exceededRecommendedPeriodDialogId: "exceeded-recommended-period",
            hasAcceptedExceededPeriod: false,
            messageExceededRecommendedPeriod: "",
            seeOldDataDialogId: "see-old-data",
            acceptedSeeOldData: false,
            loadRofTab: false,
            isDayGrouptime: true,
            channelsQueryBeforeChange: {},
            checkForFieldChanges: false,
            stringForFilterBeforeChange: "",
            latestDate: "",
            selectedBtns: [],
        }
    },
    watch: {
        "$store.getters.getChannelsQueryCost.data"(queryData) {
            // show modal
            if (queryData.queryClass == "RowLimitExceeded") {
                this.showSlowQueryModal = true
            }
            if (queryData.queryClass == "Schedule") {
                this.showScheduleReportModal = true
            }
            if (queryData.queryClass == "Forbidden") {
                this.$bvToast.toast("The execution is too demanding, limit the search or remove target groups.", {
                    title: "Server error",
                    variant: "danger",
                    solid: true,
                    autoHideDelay: 5000,
                })
            }
        },
        "$store.getters.getPublishedToDate"() {
            this.setStartAndEndDate()
        },
        async "formFields.date.start_date.tempStartDate"() {
            let endDate = this.formFields.date.end_date.tempEndDate
            let startDate = this.formFields.date.start_date.tempStartDate
            let selectedGroupTimeId = this.formFields.date.grouptime.tempGroupTime.id
            let validStartDate = dayjs(startDate, "YYYY-MM-DD").format("YYYY-MM-DD") === startDate
            let validEndDate = dayjs(endDate, "YYYY-MM-DD").format("YYYY-MM-DD") === endDate
            if (!validEndDate || !validStartDate) {
                return
            } else if (selectedGroupTimeId === "sevendays") {
                let startDateDayjsObj = dayjs(startDate, "YYYY-MM-DD")
                let newEndDate = startDateDayjsObj.add(6, "day").format("YYYY-MM-DD")
                this.formFields.date.end_date.tempEndDate = newEndDate
            } else if (selectedGroupTimeId === "week" && startDate > endDate) {
                let weekday = require("dayjs/plugin/weekday")
                dayjs.extend(weekday)
                let endDateSunday = dayjs(startDate)
                    .weekday(6)
                    .format("YYYY-MM-DD")
                this.formFields.date.end_date.tempEndDate = endDateSunday
            }
            const apiVersion = await determineApiVersion(startDate, "sites")
            if (apiVersion.appVersion === "1" && this.$store.getters.getSSASMessage.linkedSSAS != "total2_analysis_dev") {
                this.$bvModal.show(this.seeOldDataDialogId)
            }
            if (selectedGroupTimeId === "day" && startDate > endDate) {
                this.formFields.date.end_date.tempEndDate = startDate
            }
        },
        async "formFields.date.end_date.tempEndDate"() {
            let endDate = this.formFields.date.end_date.tempEndDate
            let startDate = this.formFields.date.start_date.tempStartDate
            let selectedGroupTimeId = this.formFields.date.grouptime.tempGroupTime.id
            let validStartDate = dayjs(startDate, "YYYY-MM-DD").format("YYYY-MM-DD") === startDate
            let validEndDate = dayjs(endDate, "YYYY-MM-DD").format("YYYY-MM-DD") === endDate
            if (!validEndDate || !validStartDate) {
                return
            } else if (selectedGroupTimeId === "week" && startDate > endDate) {
                let weekday = require("dayjs/plugin/weekday")
                dayjs.extend(weekday)
                let startDateMonday = dayjs(endDate)
                    .weekday(0)
                    .format("YYYY-MM-DD")
                this.formFields.date.start_date.tempStartDate = startDateMonday
            }

            const apiVersion = await determineApiVersion(startDate, "sites")
            if (apiVersion.appVersion === "1" && this.$store.getters.getSSASMessage.linkedSSAS != "total2_analysis_dev") {
                this.$bvModal.show(this.seeOldDataDialogId)
            }
            if (selectedGroupTimeId === "day" && startDate > endDate) {
                this.formFields.date.start_date.tempStartDate = endDate
                return
            }
        },
        "$store.getters.getChannelsQuery": {
            deep: true,
            handler(query) {
                this.resetFailedOrEmptyState()
                let selectedBtns = []
                let viewmode = this.formFields.date.grouptime.options.find(o => o.id == query.grouptime).label
                selectedBtns.push({
                    text: `<span class="font-weight-bold">View mode:</span> ${viewmode}`,
                    editable: false,
                    clickedBtn: () => {
                        this.formFields.date.showDateModal = true
                    },
                })
                selectedBtns.push({
                    text: `<span class="font-weight-bold">Consumption date:</span> ${query.start_date} - ${query.end_date}`,
                    editable: false,
                    clickedBtn: () => {
                        this.formFields.date.showDateModal = true
                    },
                })
                if (query.provider_keys.length > 0) {
                    selectedBtns.push({
                        text: `<span class="font-weight-bold">Channels:</span> ${query.provider_keys.length} selected`,
                        editable: true,
                        clickedBtn: () => {
                            this.formFields.providers.showChannelModal = true
                        },
                        clickedBtnDelete: event => {
                            event.stopPropagation()
                            this.query.provider_keys = []
                        },
                    })
                }
                let numberOfStoredTargets = this.getTargetGroupCount()
                if (numberOfStoredTargets > 0) {
                    let chosenText = numberOfStoredTargets > 1 ? "selected" : "selected"
                    selectedBtns.push({
                        text: `<span class="font-weight-bold"> Target / Metric </span> ${numberOfStoredTargets} ${chosenText}`,
                        editable: true,
                        clickedBtn: () => {
                            this.formFields.target_group.showTargetGroupModal = true
                        },
                        clickedBtnDelete: event => {
                            event.stopPropagation()
                            this.removeTargets()
                        },
                    })
                }
                if (query.weekdays.length > 0) {
                    selectedBtns.push({
                        text: `<span class="font-weight-bold">Weekdays:</span> ${query.weekdays.length} selected`,
                        editable: true,
                        clickedBtn: () => {
                            this.formFields.weekdays.showWeekdayModal = true
                        },
                        clickedBtnDelete: event => {
                            event.stopPropagation();
                            let updatedQuery = {
                                ...this.$store.getters["getChannelsQuery"],
                                weekdays: []
                            };
                            this.$store.commit("setChannelsQuery", updatedQuery);
                        }
                    })
                }
                this.selectedBtns = selectedBtns
            },
        },
        tabName(newVal) {
            if (newVal === "List") {
                this.hasAcceptedExceededPeriod = false
            }
        },
    },
    async mounted() {
        await this.loadGlobalConfigFromFile()
        this.init()
        let customParseFormat = require("dayjs/plugin/customParseFormat")
        dayjs.extend(customParseFormat)
    },
    computed: {
        sumVisible() {
            let sumVisible = false
            if (this.status === "LOADED") {
                sumVisible = this.$store.getters.getChannelsSumVisible
            }
            return sumVisible
        },
        showSumBtn() {
            let showSumBtn = false
            if (this.$store.getters.getChannelsResults.status == "LOADED" && this.tabName === "List") {
                showSumBtn = true
            }
            return showSumBtn
        },
        disableSumBtn() {
            let disableSumBtn = false
            if (this.$store.getters.getChannelsHasExcludedRow) disableSumBtn = true
            return disableSumBtn
        },
        getSelectedInputs() {
            let selectedInputs = this.selectedBtns.length
            return selectedInputs
        },
        allModalsClosed() {
            let allModalsClosed = false
            if (!this.formFields.date.showDateModal && !this.formFields.providers.showChannelModal && !this.formFields.target_group.showTargetGroupModal && !this.formFields.weekdays.showWeekdayModal) allModalsClosed = true
            return allModalsClosed
        },
        rofTabTitle() {
            let rofTabTitle = "Reach and frequency"
            if (!this.TargetGroupExists || !this.grouptimeIsDay) {
                rofTabTitle +=
                    !this.TargetGroupExists && !this.grouptimeIsDay
                        ? " (target group must be specified and view mode must be Day)"
                        : !this.TargetGroupExists
                        ? " (target group must be specified)"
                        : " (view mode must be Day)"
            }
            return rofTabTitle
        },
        isRofTabDisabled() {
            return !this.$store.getters.getChannelsHaveSelectedRow || !this.TargetGroupExists || !this.grouptimeIsDay
        },
        disableRunBtn() {
            let disableRunBtn = false
            let errorMsgExists = Object.values(this.formFields).some(function(field) {
                if (field.errorMsg) {
                    let errorMsg = field.errorMsg.replace(/^\s+|\s+$/gm, "")
                    if (errorMsg) return true
                }
            })
            let visibleChosenColumns = this.$store.getters.getChannelsQuery.columns
            if (visibleChosenColumns.length == 0 || this.loadingSearchResults || !this.TargetGroupExists || this.exceededConsumptionPeriodLimit || errorMsgExists) disableRunBtn = true
            return disableRunBtn
        },
        disableSelectAllBtn() {
            const allStarSelected = this.$store.getters.getChannelsAllWithStarSelected
            if (allStarSelected) return false
            else return true
        },
        result() {
            return this.$store.getters.getChannelsResults
        },
        status() {
            return this.$store.getters.getChannelsResults.status
        },
        statusRof() {
            return this.$store.getters.getChannelsRoFResults.status
        },
        // some state from vuex
        ...mapState({
            channelsInitStatus: ({ channels }) => channels.channelsInitStatus,
            query: ({ channels }) => channels.channelsQuery,
            queryForApi: ({ channels }) => channels.channelsQueryForApi,
        }),
        hiddenColumns() {
            return this.$store.getters.getChannelsColumnTypes.filter(x => x.hidden === true)
        },
        TargetGroupExists() {
            let targetGroupCount = this.$store.getters.getChannelsQuery.target_group.length

            return targetGroupCount > 0
        },
        grouptimeIsDay() {
            return this.isDayGrouptime
        },
        exportQuery() {
            return this.$store.getters.getChannelsExportQuery
        },
        exceededConsumptionPeriodLimit() {
            const maxDays = this.config_NumberOfConsumptionDaysChannel - 1
            let period = daysBetweenDates(this.$store.getters.getChannelsQuery.start_date, this.$store.getters.getChannelsQuery.end_date)
            return period > maxDays
        },
        exceededRecommendedPeriodLimit() {
            let exceededRecommendedPeriodLimit = false
            if (this.config_NumberOfConsumptionDaysChannel > this.config_NumberOfConsumptionDaysRecommendedChannel && this.$store.getters.getChannelsResults.status === "LOADED") {
                let chosenLvlOneSitesWithLevelTwoSites = this.$store.getters.getChannelsResults.data.levelOneSitesWithLevelTwoSites.filter(s => s.chosen).map(s => s.date)
                if (chosenLvlOneSitesWithLevelTwoSites.length > 0) {
                    const dayjsDates = chosenLvlOneSitesWithLevelTwoSites.map(date => dayjs(date))
                    dayjsDates.sort((a, b) => a - b)
                    const lowestDate = dayjsDates[0]
                    const highestDate = dayjsDates[dayjsDates.length - 1]
                    let period = daysBetweenDates(lowestDate, highestDate)
                    const maxDays = this.config_NumberOfConsumptionDaysRecommendedChannel - 1
                    return period > maxDays
                }
            }
            return exceededRecommendedPeriodLimit
        },
        messageSeeOldData() {
            return `Please click the 'See older data' button to make searches before the period ${this.config_ToV3ChangeDate}`
        },
        activeTabs() {
            return [
                { title: "List", condition: true },
                { title: "Reach and frequency", condition: this.config_ShowReachFrequencyChannel },
                { title: "Chart", condition: true },
            ].filter(tab => tab.condition)
        },
    },
    methods: {
        showOrHideSumInTable() {
            this.$store.commit(Mutations.setChannelsSumVisible, !this.$store.getters.getChannelsSumVisible)
        },
        getTargetGroupCount() {
            return this.query.target_group != null ? this.query.target_group.length : 0
        },
        removeTargets() {
            const updatedQuery = {
                ...this.$store.getters.getChannelsQuery,
                target_group: [],
            }
            this.$store.commit("setChannelsQuery", updatedQuery)
        },
        onKeyUp(event) {
            if (event.key === "Enter" && this.allModalsClosed) {
                this.onEnter()
            }
        },
        async handleDownloadSlowQueryModal() {
            this.$bvModal.show(this.exportDialogId)
            this.showSlowQueryModal = false
        },
        handleCancelSlowQueryModal() {
            this.showSlowQueryModal = false
        },
        onCancelDialog() {
            this.$bvModal.hide(this.exceededRecommendedPeriodDialogId)
            this.tabIndex = 0
        },
        setLoadRofTabBool(loadRofTab) {
            this.loadRofTab = loadRofTab
        },
        disableConsumtionDateTo() {
            this.formFields.end_date.editable = false
        },
        enableConsumtionDateTo() {
            this.formFields.end_date.editable = true
        },
        handleTabActivation(newTabIndex) {
            this.tabIndex = newTabIndex
            const tabTitle = this.getTabTitleByIndex(newTabIndex)
            if (!tabTitle) return
            if (newTabIndex === 1 && this.exceededRecommendedPeriodLimit && !this.hasAcceptedExceededPeriod) {
                this.$store.commit(Mutations.setChannelsRoFResults, {
                    status: "NOT_LOADED",
                })
                let startDateForApi = this.$store.getters.getChannelsQueryForApi.start_date
                let newEndDate = dayjs(startDateForApi)
                    .add(this.config_NumberOfConsumptionDaysRecommendedChannel - 1, "d")
                    .format("YYYY-MM-DD")
                this.messageExceededRecommendedPeriod = `
                        Selected period exceeds the maximum limit 
                        ${this.config_NumberOfConsumptionDaysRecommendedChannel} days for <br> reach & frequency. 
                        Click OK if you want to proceed and adjust the period to the following: ${startDateForApi} - ${newEndDate}`
                this.$bvModal.show(this.exceededRecommendedPeriodDialogId)
                return
            }
            this.tabName = tabTitle

            switch (tabTitle) {
                case "Reach and frequency":
                    this.loadRofTab = true
                    break
                case "Chart":
                    break
                case "List":
                default:
                    break
            }
        },
        acceptExceededRecommendedPeriod() {
            this.hasAcceptedExceededPeriod = true
            this.$bvModal.hide(this.exceededRecommendedPeriodDialogId)
            // Ensure we navigate to the correct tab after accepting conditions
            const tabTitle = this.getTabTitleByIndex(this.tabIndex)
            if (tabTitle === "Reach and frequency") {
                this.tabName = tabTitle
                let startDateForApi = this.$store.getters.getChannelsQueryForApi.start_date
                let newEndDate = dayjs(startDateForApi)
                    .add(this.config_NumberOfConsumptionDaysRecommendedChannel - 1, "d")
                    .format("YYYY-MM-DD")
                this.$store.commit(Mutations.setChannelsEnddate, newEndDate)
                this.loadRofTab = true
            }
        },
        addTdClassToLastSumColumns(columns) {
            let passedColumnBeforeMeasure = false
            let indexOfColumnBeforeMeasure = 0
            for (let i = 0; i < columns.length; i++) {
                if (columns[i].label == this.$store.getters.getChannelsResults.data.summary.columnBeforeMeasures || passedColumnBeforeMeasure) {
                    columns[i].tdClass = "tdSummaryDataClass"
                    if (!passedColumnBeforeMeasure) indexOfColumnBeforeMeasure = i
                    passedColumnBeforeMeasure = true
                }
            }
            if (passedColumnBeforeMeasure && indexOfColumnBeforeMeasure > 0) columns[indexOfColumnBeforeMeasure - 1].tdClass = "columnBeforeSummaryData"
            return columns
        },
        clearAllFields() {
            let systemToDate = new Date(this.$store.getters.getPublishedToDate)
            this.$store.commit(Mutations.setChannelsQuery, {
                ...this.$store.getters.getChannelsQuery,
                start_date: dateToyymmddFormat(systemToDate.setDate(systemToDate.getDate())),
                end_date: dateToyymmddFormat(systemToDate.setDate(systemToDate.getDate())),
                channels: [],
                provider_keys: [],
                target_group: [],
                columns: this.$store.getters.getChannelsDefaultColumns,
            })
        },
        excludeSelectedRows() {
            this.selectAll = false
        },
        getPanelDay(startDate, endDate) {
            let panelDay = new Date((startDate.getTime() + endDate.getTime()) / 2)
            let difference = endDate.getTime() - startDate.getTime()
            let days = Math.ceil(difference / (1000 * 3600 * 24)) + 1
            let isOdd = days % 2
            if (isOdd == 0) {
                panelDay.setDate(panelDay.getDate() + 1)
                return panelDay
            }
            return panelDay
        },
        async init() {
            try {
                document.addEventListener("keyup", this.onKeyUp)
                this.checkForFieldChanges = true
                await this.$store.commit(Mutations.setChannelsInitStatus, "LOADING")
                this.loadingFormDataValue = 33
                await this.getProviders()
                // Measures:
                const measures = await this.$store.dispatch(Actions.getChannelsMeasures)
                this.formFields.target_group.config.measures = [...measures]
                this.loadingFormDataValue = 66
                // COLUMNTYPES:
                const columns = await this.$store.dispatch(Actions.getChannelsColumnTypes)
                this.loadingFormDataValue = 100
                this.columnsField.config.options = [...columns]
                await this.$store.commit(Mutations.setChannelsColumnTypes, columns)
                await this.$store.commit(
                    Mutations.setChannelsDefaultColumns,
                    columns.filter(c => c.default_selection).map(c => c.value)
                )
                if (this.$store.getters.getPublishedToDate) this.setStartAndEndDate()
                let updatedQuery = {
                    ...this.$store.getters["getChannelsQuery"],
                    ["columns"]: this.$store.getters.getChannelsDefaultColumns,
                }
                this.$store.commit("setChannelsQuery", updatedQuery)
                // important with await for vue to update our components
                // status must be = LOADED for them to be displayed and they refresh when we set formFields,
                // if they are not displayed then they don't refresh...
                await this.$store.commit(Mutations.setChannelsInitStatus, "LOADED")
                if(!this.$store.getters.getChannelsHasSetDefaultQuery) {
                    this.$store.commit(Mutations.setChannelsQueryDefault, updatedQuery);
                    this.$store.commit(Mutations.setChannelsHasSetDefaultQuery, true);
                }
            } catch (error) {
                await this.$store.commit(Mutations.setChannelsInitStatus, "FAILED")
            }
        },

        async submitSearch() {
            this.$store.commit(Mutations.setChannelsSumVisible, false)
            this.tabIndex = 0
            this.tabName = "List"
            this.hasAcceptedExceededPeriod = false
            this.selectAll = false
            this.isDayGrouptime = this.$store.getters.getChannelsQuery.grouptime === "day" ? true : false
            if (!this.TargetGroupExists || this.exceededConsumptionPeriodLimit) return
            validationRules(this)
            const hasError = this.validateForm()
            if (hasError) {
                scrollToBottom()
                this.$store.commit(Mutations.setChannelsResults, {
                    status: "VALIDATION_FAILED",
                })
                if (this.formFields?.date?.start_date?.hasError || this.formFields?.date?.end_date?.hasError) {
                    this.formErrors.push("Please fill in start and end date correctly.")
                }
                return
            }
            this.$store.commit("setChannelsHaveSelectedRow", false)
            this.loadingSearchResults = true
            try {
                let query = {
                    ...this.$store.getters.getChannelsExportQuery,
                    sortBy: "providerName",
                    sortByDesc: false,
                }
                this.$store.commit(Mutations.setChannelsExportQuery, query)
                this.mainSortBy = "providerName"
                this.mainSortDesc = true
                await this.$store.dispatch(Actions.executeChannelsQuery)
                this.checkForFieldChanges = true
                this.$store.commit(Mutations.setChannelsQueryBeforeChange, this.query)
                this.$store.commit(Mutations.setChannelsHasExcludedRow, false)
            } catch (err) {
                this.loadingSearchResults = false
            }
            this.loadingSearchResults = false
        },
        setStartAndEndDate() {
            this.latestDate = this.$store.getters.getPublishedToDate
            let datePeriod = getChannelDatePeriod(this.$store.getters)
            this.$store.commit(Mutations.setChannelsEnddate, datePeriod.endDate)
            this.$store.commit(Mutations.setChannelsStartdate, datePeriod.endDate)
            this.formFields.date.start_date.datePeriod = datePeriod
            this.formFields.date.end_date.datePeriod = datePeriod
            this.formFields.date.grouptime.datePeriod = datePeriod
        },
        async getProviders() {
            const providers = await this.$store.dispatch(Actions.getChannelsProviders)
            const sites = providers.filter(x => x.provider_type == "SITE" && (x.exists_content || x.exists_site || x.exists_ad))
            const channels = providers
                .filter(x => x.provider_type == "CHANNEL" && (x.exists_content || x.exists_site || x.exists_ad))
                .reduce((p, c) => {
                    return { ...p, [c.provider_group]: [...(p[c.provider_group] ?? []), c] }
                }, {})

            const newFields = {
                ...this.formFields,
                providers: { ...this.formFields.providers, sites: sites, channels: channels },
            }

            this.formFields = newFields
        },
        onEnter() {
            if (!this.disableRunBtn) this.submitSearch()
        },
        userClickedExport() {
            this.$bvModal.show(this.exportDialogId)
        },
        userClickedExportRoF() {
            this.$store.dispatch(Actions.executeChannelsRoFExport)
        },
        selectExportMode() {
            if (this.tabName === "List") {
                this.exportResult()
            }
        },
        async handleScheduleReportSubmit(reportname) {
            this.loadingScheduleReport = true
            try {
                const options = { reportname: reportname }

                let query = {
                    ...this.$store.getters.getChannelsExportQuery,
                    sortBy: this.mainSortBy,
                    sortByDesc: this.mainSortDesc,
                }
                await this.$store.commit(Mutations.setChannelsExportQuery, query)
                await this.$store.dispatch(Actions.executeScheduleQuery, options)

                this.$bvToast.toast("The execution is scheduled, you will receive an email when it's ready.", {
                    title: "Scheduled execution",
                    variant: "success",
                    solid: true,
                    autoHideDelay: 5000,
                })
            } catch (error) {
                this.loadingScheduleReport = false
                this.showScheduleReportModal = false
                this.$bvToast.toast("Could not schedule the report execution", {
                    title: "Server error",
                    variant: "danger",
                    solid: true,
                    autoHideDelay: 5000,
                })
            } finally {
                this.loadingScheduleReport = false
                this.showScheduleReportModal = false
            }
        },
        handleScheduleReportCancel() {
            this.showScheduleReportModal = false
        },
        async exportResult() {
            this.loadingExportResults = true
            let exportToCsv
            let query = {
                ...this.$store.getters.getChannelsExportQuery,
                sortBy: this.mainSortBy,
                sortByDesc: this.mainSortDesc,
            }
            try {
                await this.$store.commit(Mutations.setChannelsExportQuery, query)
                exportToCsv = await this.$store.dispatch(Actions.executeExportChannelsQuery)
            } catch (error) {
                this.showMsg("Server error", "Could not export channels", "danger")
                this.loadingExportResults = false
                return
            }
            let fileName = ""
            let isResult = this.status === "LOADED"
            let startEndDateText = ""
            if (isResult) startEndDateText = `${this.queryForApi.start_date}_${this.queryForApi.end_date}`
            else startEndDateText = `${this.query.start_date}_${this.query.end_date}`
            if (this.$store.getters.getExcelExportFilePreName == undefined || this.$store.getters.getExcelExportFilePreName == "") {
                fileName = `CROSS-PLATFORM_Channels_${startEndDateText}`
            } else {
                fileName = `${this.$store.getters.getExcelExportFilePreName} CROSS-PLATFORM_Channels_${startEndDateText}`
            }
            download(exportToCsv, `${fileName}.csv`, null)
            this.loadingExportResults = false
        },
        showMsg(title, msg, variant) {
            this.$bvToast.toast(msg, {
                title: title,
                variant: variant,
                solid: true,
                autoHideDelay: 5000,
            })
        },
        showChartStyle(show) {
            if (show === true) {
                this.bodyClass = "chart-body"
                this.tabContainerClass = "chart-tab-container"
                this.tabContentContainer = "mt-3 chart-content-container"
            } else {
                this.bodyClass = "body"
                this.tabContainerClass = ""
                this.tabContentContainer = "mt-3"
            }
        },
        resetFailedOrEmptyState() {
            if (this.$store.getters.getChannelsResults.status == "FAILED" || this.$store.getters.getChannelsResults.status == "EMPTY_RESULT") {
                const updatedQuery = {
                    ...this.$store.getters.getChannelsResults,
                    status: "NOT_LOADED",
                }
                this.$store.commit(Mutations.setChannelsResults, updatedQuery)
            }
        },
        async onCancelSeeOldDataDialog() {
            this.$store.commit(Mutations.setChannelsStartdate, this.config_ToV3ChangeDate)
            this.$store.commit(Mutations.setChannelsEnddate, this.config_ToV3ChangeDate)
        },
        onAcceptSeeOldDataDialog() {
            window.location.href = `${this.config_TotalFrontendv1Url}/channels`
        },
        onHideSeeOldDataDialog() {
            this.onCancelSeeOldDataDialog()
        },
        isValidDate(date) {
            return dayjs(date, "YYYY-MM-DD").format("YYYY-MM-DD") === date
        },
        getTabTitleByIndex(index) {
            const tab = this.activeTabs.length > index ? this.activeTabs[index] : null
            return tab ? tab.title : null
        },
        findTabIndexByTitle(title) {
            return this.activeTabs.findIndex(tab => tab.title === title)
        },
        handleChartButtonClick() {
            const chartTabIndex = this.findTabIndexByTitle("Chart")
            if (chartTabIndex !== -1) {
                this.tabIndex = chartTabIndex
                this.tabName = "Chart"
                this.showChartStyle(true)
            } else {
                console.error("Chart tab not found")
            }
        },
    },
}
</script>

<style>
.body {
    background-color: white;
    padding: 20px 30px;
}
.chart-body {
    background-color: white;
    padding: 20px 30px;
    display: flex;
    flex-direction: column;
    min-height: 100%;
}
.tab-section {
    max-height: 100%;
    flex: 1;
}
.chart-tab-container {
    flex-grow: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
}
.chart-content-container {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;
    height: 100%;
}
.chart-content {
    background-color: white;
    min-height: 25rem;
    flex-grow: 1;
    position: relative;
}
.totalRowsStyle {
    margin-left: 10px;
    margin-top: 8px;
}
.searchbutton {
    width: 8vw;
}
.label-text {
    font-weight: 713;
    font-size: 11px;
    color: #495057;
    float: left;
    margin-bottom: 0.35rem;
}
.nav-tabs {
    font-size: 80%;
    font-weight: 400;
    align-items: center;
}
.measure-header {
    text-align: right;
    line-height: 1.1;
}
</style>

<style scoped>
>>> .tooltip-inner {
    white-space: nowrap;
    max-width: 350px;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
